export const SUPPORTED_LANGUAGES = ['en', 'hi', 'gu', 'mr', 'kn', 'ta', 'te', 'bn'] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  en: 'English',
  hi: 'हिन्दी',
  gu: 'ગુજરાતી',
  mr: 'मराठी',
  kn: 'ಕನ್ನಡ',
  ta: 'தமிழ்',
  te: 'తెలుగు',
  bn: 'বাংলা',
};

export const I18N_NAMESPACES = ['common', 'home', 'trackOrder'] as const;
